
import axios from 'axios';
axios.defaults.withCredentials = true

//拦截器
// axios.interceptors.response.use(function(ret){
//     console.log(ret);
//     return ret.data;
// })

function buildInvalidUrlResponse(url) {
    return {
        code: 'CONFIG_ERROR',
        message: '接口地址未配置，请检查前端 domain 配置',
        invalidUrl: url
    };
}

const ajax={
    post:function(url,data){
        if(!url || url === 'undefined'){
            console.error('Invalid ajax post url:', url, data)
            return Promise.resolve(buildInvalidUrlResponse(url));
        }
        console.log(url)
        return new Promise((resolve)=>{
            axios.post(url,{
                data:data
            })
            .then(ret=>{
                resolve(ret.data)
            })
            .catch(err=>{
                resolve(err)
            })
        })
        //使用拦截器时使用
        // return axios.post(url,{
        //     data:data
        // })
    },
    postBlob:function(url,data,config={}){
        if(!url || url === 'undefined'){
            console.error('Invalid ajax postBlob url:', url, data)
            return Promise.resolve(buildInvalidUrlResponse(url));
        }
        return axios.post(url,{
            data:data
        },Object.assign({
            responseType:'blob'
        },config))
    },
    get:function(url,data){
        if(!url || url === 'undefined'){
            console.error('Invalid ajax get url:', url, data)
            return Promise.resolve(buildInvalidUrlResponse(url));
        }
        return axios.get(url)
    }
}

export default ajax


// WEBPACK FOOTER //
// ./src/service/ajax.js